/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { modalTitleStyles } from "./UserModalStyles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function MFAModal({
  status,
  openMFAModal,
  handleMFAClose,
  handleMFACancel,
}) {
  const onClose = handleMFACancel || handleMFAClose;

  return (
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={openMFAModal}
        slotProps={{
          paper: {
            sx: {
              width: "423px",
              maxHeight: "196px",
              borderRadius: "8px",
              padding: "24px",
              display: "flex",
              gap: "24px",
            },
          },
        }}
      >
        <Box
          sx={{
            minWidth: "375px",
            minHeight: "88px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          <div>
            <Typography
              sx={modalTitleStyles}
            >
              {status ? "Disable" : "Enable"} Multi-Factor Authentication
            </Typography>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <Typography
            sx={{
              width: "375px",
              height: "40px",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "140%",
              letterSpacing: "0.15px",
              color: "#5A5B5C",
            }}
          >
            Are you sure you want to {status ? "Disable" : "Enable"} the
            Multi-factor authentication ?
          </Typography>
        </Box>

        <DialogActions>
          <Button
            sx={{
              textTransform: "none",
            }}
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: "none",
              color: status ? "#B50B00" : "#fff",
              border: `1px solid ${status ? "#B50B00" : "#0476E2"}`,
            }}
            variant={status ? "outlined" : "contained"}
            onClick={handleMFAClose}
          >
            {status ? "Disable" : "Enable"}
          </Button>
        </DialogActions>
      </BootstrapDialog>
  );
}

MFAModal.propTypes = {
  status: PropTypes.bool.isRequired,
  openMFAModal: PropTypes.bool.isRequired,
  handleMFAClose: PropTypes.func.isRequired,
  handleMFACancel: PropTypes.func,
};
